class LayoutTemplateService extends BaseService
	@register()
	@inject 'translate',
		'Guid'
		'ImageService'
		'BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE'

	initTemplate: (template) ->
		if _.isEmpty template
			template =
				dimension_x: 5
				dimension_y: 5
				layout_folders: []

		template.dimension_x = parseInt template.dimension_x
		template.dimension_y = parseInt template.dimension_y

		if !template.id?
			template.entity_type = @BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.POS
			@initializeRootFolder(template)

			return template

		@initializeImages(template)
		@cleanOrphanItems(template)
		@afterLoad(template)

		return template

	cleanOrphanItems: (template) ->
		seenFolders = {}
		seenItems = {}

		for folder in template.layout_folders
			seenFolders[folder.id] = folder.name if folder.parent_id?

			for item in folder.items
				if item.product_id? && !item.product?
					console.warn "#{item.id} has non-existing product associated - deleting"

					template.is_changed = true
					folder.items = _.reject folder.items, {id: item.id}

				if item.layout_folder_id?
					seenItems[item.layout_folder_id] = item.layout_folder.name

		for own id, name of seenFolders
			if !seenItems[id]?
				template.is_changed = true
				console.warn "#{id} - #{name} is orphan folder - deleting"

				@removeFolder template, id

	##
	# Makes a copy of the DTO
	# returns the entire model object
	##
	copy: (templateOrigin) ->
		templateCopy = angular.copy templateOrigin
		delete templateCopy.id

		templateCopy.name = templateCopy.name + " (#{@translate('general.a.copy')})"

		layoutFolderMap = {}

		for [original, copy] in _.zip(templateOrigin.layout_folders, templateCopy.layout_folders)
			copy.id = @Guid.generate()
			layoutFolderMap[original.id] = copy.id
			copy.image.file = original.image.file

		for layoutFolder in templateCopy.layout_folders
			layoutFolder.parent_id = layoutFolderMap[layoutFolder.parent_id] ? null

			if parseInt(layoutFolder.depth) > 0
				for page in layoutFolder.pages
					for item in page.items
						@remapItemIds(item, layoutFolder.id, layoutFolderMap)
			else
				for item in layoutFolder.items
					@remapItemIds(item, layoutFolder.id, layoutFolderMap)


		return templateCopy

	remapItemIds: (item, layoutFolderId, layoutFolderMap) ->
		delete item.id

		item.owner_layout_folder_id = layoutFolderId

		if item.layout_folder_id?
			item.layout_folder_id = layoutFolderMap[item.layout_folder_id] ? null

	##
	# Parse location to grid coordinates
	##
	afterLoad: (template) ->
		for folder in template.layout_folders
			if parseInt(folder.depth) != 0
				folder.current_page = 1
				folder.pages = []
				@buildPages template, folder

			for item in folder.items
				if item.product
					item.product.color = @getHexColor item.product.color

				if parseInt(folder.depth) != 0
					coords = @locationToCoordinates template, item.location, template.dimension_x

					item.computed_values =
						gridOption:
							row: coords.row
							col: coords.col
							sizeX: 1
							sizeY: 1

	##
	# Parse coordinate to location before saving
	##
	beforeTemplateSave: (templateOrigin) ->
		delete templateOrigin.is_changed

		for folder in templateOrigin.layout_folders
			filledItems = []

			if parseInt(folder.depth) > 0
				folder.items = []

				for page in folder.pages
					for item in page.items
						location = @coordinateToLocation templateOrigin, item.computed_values.gridOption

						item.location = location + ((page.page_number - 1) * @getPageSize(templateOrigin))

						# Add to filled items if it actually contains data
						if item.product_id or item.layout_folder_id
							filledItems.push item

					folder.items = filledItems

		templateToSave = angular.copy templateOrigin

		##
		# Delete relation and computed values
		##
		for folder in templateToSave.layout_folders
			if !folder.image.file?
				folder.image = folder.image.url
			else
				delete folder.image

			delete folder.parent
			delete folder.computed_values
			delete folder.pages
			delete folder.current_page
			delete folder.layout_template
			delete folder.layout_template_id

			for item in folder.items
				delete item.computed_values
				delete item.product
				delete item.layout_folder
				delete item.css_image_url

		return templateToSave

	beforeFolderSave: (folderOrigin) ->
		folderCopy = angular.copy(folderOrigin)
		folderCopy.image = folderOrigin.image.file

		delete folderCopy.parent
		delete folderCopy.computed_values
		delete folderCopy.pages
		delete folderCopy.current_page
		delete folderCopy.layout_template
		delete folderCopy.layout_template_id
		delete folderCopy.items

		return folderCopy

	##
	# Returns the page size
	##
	getPageSize: (template) ->
		return template.dimension_x * template.dimension_y

	##
	# Hack to handle the different handling of color formats between web and IOS
	##
	getHexColor: (color) ->
		if !color
			return null

		return color

	##
	# Fill the folder items array with empty items if neither folder or product is set on that specific location
	##
	buildPages: (template, folder) ->
		##
		# Returns highest location of the last page in the folder
		##
		calcMax = (page, count, max) ->
			if page * count < max
				return calcMax(page, count + 1, max)

			return page * count

		# The persisted item with the highest location value
		highestLocation = @getHighestLocation(folder) + 1
		# The last location of the last item on the last page
		highestGridLocation = calcMax @getPageSize(template), 1, highestLocation

		# Loop the total number of items that the folder should have
		# index is treated as location
		for index in [0...highestGridLocation] by 1
			pageNumber = @getPageNumberByLocation template, index
			# Check if any of our persisted items is at this current location
			item = _.find folder.items, (item) -> parseInt(item.location) == index
			page = _.find folder.pages, (item) -> parseInt(item.page_number) == pageNumber

			# Page does not exist yet so create it
			if angular.isUndefined page
				page = @createNewPage(template, folder)
				folder.pages.push(page)

			# Create a new empty item if we did not find any at the current location
			if angular.isUndefined item
				item = @createEmptyItem template, index
			else
				item.css_image_url = @getItemImageCss(item)

			page.items.push item

	##
	# Calculate the page number based on a location value
	##
	getPageNumberByLocation: (template, location, count = 0) ->
		if location < count * @getPageSize(template)
			return count

		return @getPageNumberByLocation template, location, count + 1

	##
	# Gets the highest location in a folder
	##
	getHighestLocation: (folder) ->
		max = 0

		for item in folder.items
			if parseInt(item.location) > max
				max = parseInt(item.location)

		return max

	locationToCoordinates: (template, location, dimensionX = 0, row = 0) ->
		dimensionX = parseInt dimensionX
		locationCopy = parseInt(angular.copy(location))
		page = @getPageNumberByLocation template, locationCopy
		locationCopy = locationCopy - ((page - 1) * @getPageSize(template))

		if locationCopy < dimensionX
			col = locationCopy - (row * parseInt(template.dimension_x))

			return {row: row, col: col}

		return @locationToCoordinates template, location, dimensionX + parseInt(template.dimension_x), row + 1

	##
	# Converts a coordinate to a item location
	##
	coordinateToLocation: (template, coordinate) ->
		location = null

		if parseInt(coordinate.row) == 0
			location = parseInt coordinate.col
		else
			location = (parseInt(coordinate.row) * parseInt(template.dimension_x)) + parseInt(coordinate.col)

		return location

	##
	# Initialize the root folder if we have a new layout
	# Create sub folder to root and fill it with empty items
	##
	initializeRootFolder: (template) ->
		rootFolder = @createEmptyFolder template, 0, "Root folder", false
		newFolder = @createSubFolder template, rootFolder

		rootFolder.items.push {
			location: rootFolder.items.length
			layout_folder_id: newFolder.id
			owner_layout_folder_id: null
			product_id: null
			product: null
			layout_folder: newFolder
			computed_values: {}
		}

		template.layout_folders.push rootFolder

	##
	# Returns the folder at depth 0 (top level)
	##
	getRootFolder: (template) ->
		rootFolder = _.find template.layout_folders, (folder) -> parseInt(folder.depth) == 0

		rootFolder.items = _.sortBy rootFolder.items, 'location'

		return rootFolder

	##
	# Returns the parent folder if any exists
	##
	getParent: (template, folder) ->
		return _.find template.layout_folders, {id: folder.parent_id}

	##
	# Recursively find the path of the current folder
	##
	getFolderPath: (template, folder, path = []) ->
		if !folder || parseInt(folder.depth) == 0
			return path

		path.unshift
			name: folder.name
			depth: folder.depth
			id: folder.id

		return @getFolderPath(template, @getParent(template, folder), path)

	##
	# Returns main folder (one level above root folder)
	##
	getMainFolder: (template, folder) ->
		if parseInt(folder.depth) == 1
			return folder

		return @getMainFolder(template, @getParent(template, folder))

	##
	# Create an empty folder
	# along with empty grid items by default
	##
	createEmptyFolder: (template, depth, name, createItems = true) ->
		folder =
			id: @Guid.generate()
			name: name
			depth: depth
			parent_id: null
			parent: null
			layout_template_id: null
			layout_template: null
			items: []
			computed_values: {}
			pages: []
			current_page: 1
			color: null
			image: {
				url: null,
				file: null,
			}
		page = @createNewPage(template, folder)

		numItems = template.dimension_x * template.dimension_y

		if createItems
			for index in [0...numItems] by 1
				item = @createEmptyItem template, index
				page.items.push item

		folder.pages.push page

		return folder

	##
	# Creates a sub folder to the inputed folder
	# Note that folders a not stores as a tree but just with a parent reference
	##
	createSubFolder: (template, folder) ->
		newFolder = @createEmptyFolder(template, parseInt(folder.depth) + 1, 'New folder')
		newFolder.parent_id = folder.id

		template.layout_folders.push(newFolder)

		return newFolder

	##
	# Creates a new pages
	##
	createNewPage: (template, folder, fillWithEmptyItems = false) ->
		page =
			page_number: folder.pages.length + 1,
			items: []

		if !fillWithEmptyItems
			return page

		for index in [0...@getPageSize(template)] by 1
			item = @createEmptyItem template, index
			cord = @locationToCoordinates template, item.location, template.dimension_x
			item.computed_values.gridOption =
				row: cord.row
				col: cord.col
				sizeX: 1
				sizeY: 1
			page.items.push item

		return page

	##
	# Creates a new item
	##
	createEmptyItem: (template, location) ->
		item =
			location: location
			layout_folder_id: null
			owner_layout_folder_id: null
			product_id: null
			product:  null
			layout_folder: null
		coordinates = @locationToCoordinates template, item.location, template.dimension_x
		item.computed_values =
			gridOption:
				row: coordinates.row
				col: coordinates.col
				sizeX: 1
				sizeY: 1

		return item

	##
	# Removes a folder from the layout_folders array
	##
	removeFolder: (template, folderId) ->
		return if !folderId?

		folder = _.find template.layout_folders, {id: folderId}

		if !folder?
			return

		if !_.isEmpty(folder.items)
			for item in folder.items
				@removeFolder template, item.layout_folder_id

		template.layout_folders = _.reject template.layout_folders, {id: folderId}

	initializeImages: (template) ->
		for folder in template.layout_folders
			folder.image = {url: folder.image, file: null}

			for item in folder.items
				if !item.layout_folder_id?
					continue

				item.layout_folder.image = {url: item.layout_folder.image, file: null}

	getItemImageCss: (item) ->
		if item.product?.image
			return "url(#{@ImageService.resize(item.product.image)})"

		if item.layout_folder?.image.url
			return "url(#{@ImageService.resize(item.layout_folder.image.url)})"

		return null

	###
	Replace existing Predefined Template folders IDs with new ones.
	Root Folder ID must be changed to existing Root Folder ID, not to newly generated ID
	###
	anonymizeFolders: (folders, rootFolder, template) ->
		idMap = {
			null: null
		}

		for folder in folders
			if parseInt(folder.depth) == 0
				idMap[folder.id] = rootFolder.id
			else
				idMap[folder.id] ?= @Guid.generate()

			for item in folder.items
				idMap[item.id] ?= @Guid.generate()

		for folder in folders
			folder.id = idMap[folder.id]
			folder.layout_template_id = template.id
			folder.parent_id = idMap[folder.parent_id]

			for item in folder.items
				item.id = idMap[item.id]
				item.owner_layout_folder_id = idMap[item.owner_layout_folder_id]

				if item.layout_folder?
					item.layout_folder.id = idMap[item.layout_folder.id]
					item.layout_folder.layout_template_id = template.id
					item.layout_folder.parent_id = idMap[item.layout_folder.parent_id]

				item.layout_folder_id = idMap[item.layout_folder_id]

		return folders
